import { Component } from '@angular/core';

@Component({
    selector: 'ca-page-header',
    templateUrl: './page-header.component.html',
    standalone: false
})
export class CaPageHeaderComponent {}
